export const updateRespondentsData = [{
    key: 'min_respondent',
    type: 'number',
    value: '',
    valid: false,
    min: 3,
    max: 50,
    elementConfig: {
        name: 'min_respondent',
        label: 'Min. Respondents',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },
}, {
    key: 'id',
    type: 'hidden',
    value: '',
    valid: true,
    elementConfig: {
        name: 'id',
        // label: 'id',
        placeholder: ''
    },
    validation: {
        required: false,
        message: ""
    },
}]




// WEBPACK FOOTER //
// ./src/_pages/Admin/DevelopmentPlan/developmentPlanFormData.js